import { chain } from 'lodash';

export const DefaultOpenTemplateTextChar = '{';
export const DefaultCloseTemplateTextChar = '}';

export const ContactCandidatesTextTemplateValues = {
    candidateName: 'prospectFirstName',
    candidateFirstName: 'candidateFirstName',
    candidateLastName: 'candidateLastName',
    candidateSkill: 'candidateSkill',
    candidateCurrentCompany: 'candidateCurrentCompany',
    candidatePastCompany: 'candidatePastCompany',
    candidatePastJobTitle: 'candidatePastJobTitle',
    employerRepName: 'employerRepName',
    employerRepFirstName: 'employerRepFirstName',
    employerRepEmail: 'employerRepEmail',
    employerCompanyName: 'employerName',
    employerCompanyWebsite: 'employerCompanyWebsite',
    positionJobTitle: 'jobTitle',
    positionLocation: 'positionLocation',
    positionDescriptionLink: 'positionApproveLink',
    recruiterName: 'teName',
    recruiterFirstName: 'teFirstName',
    recruiterEmail: 'teEmail',
    recruiterPhone: 'tePhone',
    recruiterJobTitle: 'teJobTitle',
    iHaveAQuestion: 'iHaveAQuestion',
    iHaveAComment: 'iHaveAComment',
    atsJobUrl: 'atsJobUrl',
    positionDescriptionThisPageLink: 'positionApproveThisPageLink',
    positionDescriptionHereLink: 'positionApproveHereLink',
    positionDescriptionPageLink: 'positionApprovePageLink',
    unsubscribeLink: 'unsubscribeLink',
    companyVideoLink: 'companyVideoLink',
};

export const TextTemplateValues = {
    ...ContactCandidatesTextTemplateValues,
    jobLocation: 'jobLocation',
    campaignStatus: 'campaignStatus',
    emailStatus: 'emailStatus',
    linkedinStatus: 'linkedinStatus',
    senderName: 'senderName',
    userName: 'userName',
    userEmail: 'userEmail',
    talentName: 'talentName',
    talentLink: 'talentLink',
    companyName: 'companyName',
    creditExpirationDate: 'creditExpirationDate',
    location: 'location',
    linkedIn: 'linkedIn',
    expirationDate: 'expirationDate',
    employerPositionLink: 'employerPositionLink',
    userToDeleteName: 'userToDeleteName',
    adminName: 'adminName',
    percentageOfCredits: 'percentageOfCredits',
    prospectName: 'prospectName',
    autoCampaignType: 'autoCampaignType',
    selectedDiversityTarget: 'selectedDiversityTarget',
    currentStatus: 'currentStatus',
    previousStatus: 'previousStatus',
    accountManagerFullName: 'accountManagerFullName',
    accountManagerEmail: 'accountManagerEmail',
    recipientName: 'recipientName',
    delayInDaysBeforeContactCandidates: 'delayInDaysBeforeContactCandidates',
    CSRecruiterManagerName: 'CSRecruiterManagerName',
    CSRecruiterManagerEmail: 'CSRecruiterManagerEmail',
    inviteEmployerRepLink: 'inviteEmployerRepLink',
    link: 'link',
    clickHereLink: 'clickHereLink',
    jobTitleLink: 'jobTitleLink',
    optOutReason: 'optOutReason',
    previousEmployerRepName: 'previousEmployerRepName',
    newEmployerRepName: 'newEmployerRepName',
    viewPrivacyAndGdprCompliancePolicyLink: 'viewPrivacyAndGdprCompliancePolicyLink',
    watchThisTrainingVideoLink: 'watchThisTrainingVideoLink',
};

export const TemplateTextLinks = [
    TextTemplateValues.positionDescriptionLink,
    TextTemplateValues.iHaveAQuestion,
    TextTemplateValues.iHaveAComment,
    TextTemplateValues.atsJobUrl,
    TextTemplateValues.employerPositionLink,
    TextTemplateValues.inviteEmployerRepLink,
    TextTemplateValues.clickHereLink,
    TextTemplateValues.jobTitleLink,
    TextTemplateValues.link,
    TextTemplateValues.viewPrivacyAndGdprCompliancePolicyLink,
    TextTemplateValues.watchThisTrainingVideoLink,
    TextTemplateValues.positionDescriptionThisPageLink,
    TextTemplateValues.positionDescriptionHereLink,
    TextTemplateValues.positionDescriptionPageLink,
    TextTemplateValues.unsubscribeLink,
    TextTemplateValues.companyVideoLink,
];

export const TemplateTextDynamic = {
    employerRepLinkedin: 'employerRepLinkedin',
    howDidIFindYouLink: 'howDidIFindYouLink',
    poweredByLink: 'poweredByLink',
    employerCompanyLink: 'employerCompanyLink',
    employerRepPhone: 'employerRepPhone',
    employerRepJobTitle: 'employerRepJobTitle',
    employerLinkedin: 'employerLinkedin',
};

export const TemplateTextDynamicValueDisplayLabelMap = {
    [TemplateTextDynamic.employerRepLinkedin]: 'Recruiting LinkedIn',
    [TemplateTextDynamic.howDidIFindYouLink]: 'Why Did We Contact You?',
    [TemplateTextDynamic.poweredByLink]: 'Powered by PaycorSmartSourcing',
    [TemplateTextDynamic.employerCompanyLink]: 'Company (Hyperlink)',
    [TemplateTextDynamic.employerRepPhone]: 'Recruiter Phone',
    [TemplateTextDynamic.employerRepJobTitle]: 'Recruiter Job Title',
    [TemplateTextDynamic.employerLinkedin]: 'Company LinkedIn',
};

export const ContactCandidateTemplateTextValueDisplayLabelMap = {
    [TextTemplateValues.candidateName]: 'Candidate Name',
    [TextTemplateValues.candidateFirstName]: 'Candidate First Name',
    [TextTemplateValues.candidateLastName]: 'Candidate Last Name',
    [TextTemplateValues.candidateSkill]: 'Candidate Skill',
    [TextTemplateValues.candidateCurrentCompany]: 'Candidate Current Company',
    [TextTemplateValues.candidatePastCompany]: 'Candidate Past Company',
    [TextTemplateValues.candidatePastJobTitle]: 'Candidate Past Job Title',
    [TextTemplateValues.employerCompanyName]: 'Company Name',
    [TextTemplateValues.employerCompanyWebsite]: 'Company Website',
    [TextTemplateValues.employerRepName]: 'Recruiter Name',
    [TextTemplateValues.employerRepFirstName]: 'Recruiter First Name',
    [TextTemplateValues.employerRepEmail]: 'Recruiter Email',
    [TextTemplateValues.positionJobTitle]: 'Job title',
    [TextTemplateValues.positionLocation]: 'Job Location',
    [TextTemplateValues.positionDescriptionLink]: 'Job Description',
    [TextTemplateValues.recruiterName]: 'TE Name',
    [TextTemplateValues.recruiterFirstName]: 'TE First Name',
    [TextTemplateValues.recruiterEmail]: 'TE Email',
    [TextTemplateValues.iHaveAQuestion]: 'I have a question',
    [TextTemplateValues.iHaveAComment]: 'I have a comment',
    [TextTemplateValues.atsJobUrl]: 'Apply on company website',
    [TextTemplateValues.positionDescriptionThisPageLink]: 'this page',
    [TextTemplateValues.positionDescriptionHereLink]: 'here',
    [TextTemplateValues.positionDescriptionPageLink]: 'page',
    [TextTemplateValues.unsubscribeLink]: 'unsubscribe',
    [TextTemplateValues.companyVideoLink]: 'Company Video (hyperlink)',
};

export const TemplateTextValueDisplayLabelMap = {
    ...ContactCandidateTemplateTextValueDisplayLabelMap,
    ...TemplateTextDynamicValueDisplayLabelMap,
    [TextTemplateValues.jobLocation]: 'Job Location',
    [TextTemplateValues.campaignStatus]: 'Campaign Status',
    [TextTemplateValues.emailStatus]: 'Email Status',
    [TextTemplateValues.linkedinStatus]: 'LinkedIn Status',
    [TextTemplateValues.senderName]: 'Sender Name',
    [TextTemplateValues.userName]: 'User Name',
    [TextTemplateValues.userEmail]: 'User Email',
    [TextTemplateValues.talentName]: 'Talent Name',
    [TextTemplateValues.talentLink]: 'Talent Link',
    [TextTemplateValues.companyName]: 'Company Name',
    [TextTemplateValues.creditExpirationDate]: 'Credit Expiration Date',
    [TextTemplateValues.expirationDate]: 'Expiration Date',
    [TextTemplateValues.employerPositionLink]: 'Job Description',
    [TextTemplateValues.userToDeleteName]: 'User To Delete Name',
    [TextTemplateValues.adminName]: 'Admin Name',
    [TextTemplateValues.percentageOfCredits]: 'Percentage Of Credits',
    [TextTemplateValues.prospectName]: 'Prospect Name',
    [TextTemplateValues.selectedDiversityTarget]: 'Selected Diversity Target',
    [TextTemplateValues.currentStatus]: 'Current Status',
    [TextTemplateValues.previousStatus]: 'Previous Status',
    [TextTemplateValues.autoCampaignType]: 'Auto Campaign Type',
    [TextTemplateValues.accountManagerFullName]: 'Account Manager FullName',
    [TextTemplateValues.accountManagerEmail]: 'Account Manager Email',
    [TextTemplateValues.recipientName]: 'Recipient Name',
    [TextTemplateValues.delayInDaysBeforeContactCandidates]: 'Delay In Days Before Contact Candidates',
    [TextTemplateValues.CSRecruiterManagerEmail]: 'CSRecruiter Manager Email',
    [TextTemplateValues.CSRecruiterManagerName]: 'CSRecruiter Manager Name',
    [TextTemplateValues.inviteEmployerRepLink]: 'Click Here',
    [TextTemplateValues.clickHereLink]: 'Click Here',
    [TextTemplateValues.jobTitleLink]: 'Job Title',
    [TextTemplateValues.link]: 'link',
    [TextTemplateValues.viewPrivacyAndGdprCompliancePolicyLink]: 'View Privacy and GDPR Compliance policy',
    [TextTemplateValues.watchThisTrainingVideoLink]: 'Watch this training video',
    [TextTemplateValues.previousEmployerRepName]: 'Previous Employer Rep Name',
    [TextTemplateValues.newEmployerRepName]: 'New Employer Rep Name',
};

export const ToolbarOptionsTemplateTextValueLabelMap = {
    viewPrivacyAndGdprCompliancePolicyLink: 'Privacy & Policy',
    watchThisTrainingVideoLink: 'Training video',
};

export const ActionsTemplateValues = {
    candidateFeedback: 'candidateFeedbackBtns',
    alreadyAppliedButton: 'alreadyAppliedButton',
    findOutMoreButton: 'findOutMoreButton',
    notInterestedButton: 'notInterestedButton',
    giveFeedbackButton: 'giveFeedbackButton',
    rateProfilesButton: 'rateProfilesButton',
};

export const TemplateTextOptionsEmployerRep = [
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_ATS_JOB_URL',
        value: TextTemplateValues.atsJobUrl,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_CANDIDATE_FIRST_NAME',
        value: TextTemplateValues.candidateFirstName,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_CANDIDATE_LAST_NAME',
        value: TextTemplateValues.candidateLastName,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_CANDIDATE_NAME',
        value: TextTemplateValues.candidateName,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_CANDIDATE_SKILL',
        value: TextTemplateValues.candidateSkill,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_CANDIDATE_CURRENT_COMPANY',
        value: TextTemplateValues.candidateCurrentCompany,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_CANDIDATE_PAST_COMPANY',
        value: TextTemplateValues.candidatePastCompany,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_CANDIDATE_PAST_JOB_TITLE',
        value: TextTemplateValues.candidatePastJobTitle,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_EMPLOYER_REP_NAME',
        value: TextTemplateValues.employerRepName,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_EMPLOYER_REP_FIRST_NAME',
        value: TextTemplateValues.employerRepFirstName,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_EMPLOYER_REP_EMAIL',
        value: TextTemplateValues.employerRepEmail,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_EMPLOYER_REP_PHONE',
        value: TemplateTextDynamic.employerRepPhone,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_EMPLOYER_REP_JOB_TITLE',
        value: TemplateTextDynamic.employerRepJobTitle,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_EMPLOYER_REP_LINKEDIN',
        value: TemplateTextDynamic.employerRepLinkedin,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_EMPLOYER_COMPANY_NAME',
        value: TextTemplateValues.employerCompanyName,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_EMPLOYER_COMPANY_WEBSITE',
        value: TextTemplateValues.employerCompanyWebsite,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_EMPLOYER_COMPANY_HYPERLINK',
        value: TemplateTextDynamic.employerCompanyLink,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_EMPLOYER_COMPANY_LINKEDIN',
        value: TemplateTextDynamic.employerLinkedin,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_EMPLOYER_POSITION_JOB_TITLE',
        value: TextTemplateValues.positionJobTitle,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_EMPLOYER_POSITION_LOCATIONS',
        value: TextTemplateValues.positionLocation,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_JOB_DESCRIPTION_LINK',
        value: TextTemplateValues.positionDescriptionLink,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_EMPLOYER_I_HAVE_A_QUESTION',
        value: TextTemplateValues.iHaveAQuestion,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_EMPLOYER_I_HAVE_A_COMMENT',
        value: TextTemplateValues.iHaveAComment,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_THIS_PAGE',
        value: TextTemplateValues.positionDescriptionThisPageLink,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_HERE',
        value: TextTemplateValues.positionDescriptionHereLink,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_PAGE',
        value: TextTemplateValues.positionDescriptionPageLink,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_UNSUBSCRIBE',
        value: TextTemplateValues.unsubscribeLink,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_PRIVACY_AND_POLICY',
        value: TextTemplateValues.viewPrivacyAndGdprCompliancePolicyLink,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_COMPANY_VIDEO_URL',
        value: TextTemplateValues.companyVideoLink,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_HOW_DID_I_FIND_YOU',
        value: TemplateTextDynamic.howDidIFindYouLink,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_POWERED_BY',
        value: TemplateTextDynamic.poweredByLink,
    },
];

export const TemplateTextOptionsTE = [
    ...TemplateTextOptionsEmployerRep,
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_EMPLOYER_RECRUITER_FIRST_NAME',
        value: TextTemplateValues.recruiterFirstName,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_EMPLOYER_RECRUITER_NAME',
        value: TextTemplateValues.recruiterName,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_EMPLOYER_RECRUITER_EMAIL',
        value: TextTemplateValues.recruiterEmail,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_EMPLOYER_RECRUITER_PHONE',
        value: TextTemplateValues.recruiterPhone,
    },
    {
        label: 'CONTACT_CANDIDATE_EMAIL_FORM_BODY_AUTO_TEXT_EMPLOYER_RECRUITER_JOB_TITLE',
        value: TextTemplateValues.recruiterJobTitle,
    },
];

export const contactTemplateCandidateButtonValues = [
    ActionsTemplateValues.findOutMoreButton,
    ActionsTemplateValues.candidateFeedback,
    ActionsTemplateValues.notInterestedButton,
    ActionsTemplateValues.alreadyAppliedButton,
];

export const TemplateActionsValueDisplayLabelMap = {
    [ActionsTemplateValues.findOutMoreButton]: 'Find Out More',
    [ActionsTemplateValues.candidateFeedback]: 'Interested & Not Interested',
    [ActionsTemplateValues.notInterestedButton]: 'Not Interested',
    [ActionsTemplateValues.alreadyAppliedButton]: 'Already Applied',
    [ActionsTemplateValues.giveFeedbackButton]: 'Give Feedback',
    [ActionsTemplateValues.rateProfilesButton]: 'Rate Profiles',
};

export const templateButtons = [
    {
        label: 'Find Out More',
        value: ActionsTemplateValues.findOutMoreButton,
    },
    {
        label: 'Interested & Not Interested',
        value: ActionsTemplateValues.candidateFeedback,
    },
    {
        label: 'Not Interested',
        value: ActionsTemplateValues.notInterestedButton,
    },
    {
        label: 'Already Applied',
        value: ActionsTemplateValues.alreadyAppliedButton,
    },
    {
        label: 'Give Feedback',
        value: ActionsTemplateValues.giveFeedbackButton,
    },
    {
        label: 'Rate Profiles',
        value: ActionsTemplateValues.rateProfilesButton,
    },
];

export const getTemplateButtons = (values = ActionsTemplateValues) => chain(values)
    .map((value) => ({ label: TemplateActionsValueDisplayLabelMap[value] || value, value }))
    .value();

export const ContactCandidateTemplateButtons = chain(contactTemplateCandidateButtonValues)
    .map((value) => ({ label: TemplateActionsValueDisplayLabelMap[value] || value, value }))
    .value();
